import {ResourceType} from 'common/report/constants';
import {ApiDateRange} from 'common/widgets/date-range-picker/models/types';
import {CohortSegment} from 'common/query-builder/query-block/segment-menu/types';

import {FilterValue, LogicalOperator} from '../types';

export type SerializedFilterOperand = string | boolean | number | ApiDateRange | CohortSegment;
export type SerializedFilterValue = SerializedFilterOperand | SerializedFilterOperand[];

export enum SerializedResourceType {
  Literal = `literal`,
}

export enum ArithmeticOperator {
  Datetime = `$datetime`,
  Defined = `defined`,
  Equals = `==`,
  GreaterThan = `>`,
  GreaterThanEquals = `>=`,
  In = `in`,
  LessThan = `<`,
  LessThanEquals = `<=`,
  NotDefined = `not defined`,
  NotEquals = `!=`,
  NotIn = `not in`,
}

export enum TypeCastOperator {
  Boolean = `boolean`,
  Datetime = `datetime`,
  List = `list`,
  Number = `number`,
  String = `string`,
}

export type Operator = ArithmeticOperator | LogicalOperator | TypeCastOperator;

export interface Operand {
  property: ResourceType;
  value: FilterValue;
  data_group_id?: string;
  join_property_type?: string;
  scdEvent?: string;
}

export interface SerializedOperand {
  property: ResourceType | SerializedResourceType;
  value: SerializedFilterValue;
  data_group_id?: string;
  temp_data_group_id?: string;
  join_property_type?: string;
  scdEvent?: string;
}

export interface Expression {
  operator: Operator;
  children: Array<Expression | Operand>;
}
